/* Layout enhancement only. Shopify and the existing configurators own commerce state. */
(() => {
  let serial = 0;
  const slug = text => text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  const narrow = window.matchMedia('(max-width: 749px)');

  function enhanceTables(root) {
    root.querySelectorAll('table').forEach(table => {
      if (table.closest('.yz-table-scroll')) return;
      const columns = Math.max(...[...table.rows].map(row => row.cells.length), 0);
      table.dataset.columns = String(columns);
      const wrapper = document.createElement('div');
      wrapper.className = 'yz-table-scroll';
      wrapper.tabIndex = 0;
      wrapper.setAttribute('role', 'region');
      wrapper.setAttribute('aria-label', 'Tableau — défilement horizontal si nécessaire');
      table.before(wrapper);
      wrapper.append(table);
      table.querySelectorAll('th').forEach(th => { if (!th.hasAttribute('scope')) th.scope = 'col'; });
    });
  }

  function enhanceFAQ(root) {
    root.querySelectorAll('.faq-page > h3').forEach(heading => {
      const answer = [];
      let sibling = heading.nextSibling;
      while (sibling && !(sibling.nodeType === Node.ELEMENT_NODE && /^H[123]$/.test(sibling.tagName))) {
        answer.push(sibling);
        sibling = sibling.nextSibling;
      }
      if (!answer.some(node => node.textContent.trim())) return;
      const details = document.createElement('details');
      const summary = document.createElement('summary');
      summary.textContent = heading.textContent;
      heading.before(details);
      details.append(summary, ...answer);
      heading.remove();
    });
  }

  function composeServices(root) {
    root.querySelectorAll('.yzc-sec').forEach(section => {
      if (section.classList.contains('yz-editorial-section')) return;
      const heading = [...section.children].find(child => child.tagName === 'H2');
      if (!heading) return;
      const body = document.createElement('div');
      body.className = 'yz-editorial-body';
      [...section.childNodes].filter(node => node !== heading).forEach(node => body.append(node));
      section.append(body);
      section.classList.add('yz-editorial-section');
    });
  }

  function orderProductSections(root) {
    const container = root.querySelector('.yzpd');
    if (!container || container.dataset.yzOrdered) return;
    container.dataset.yzOrdered = 'true';
    const sections = [...container.children].filter(node => node.classList.contains('yzpd-sec'));
    const priority = section => {
      const title = slug(section.querySelector('h2')?.textContent || '');
      if (/caracteristiques|compatibilite/.test(title)) return 0;
      if (/composez|pack|boite/.test(title)) return 1;
      if (/points-forts/.test(title)) return 2;
      if (/questions|confiance/.test(title)) return 4;
      return 3;
    };
    if (sections.length < 3) return;
    const marker = document.createComment('Description: specifications and choices before details');
    sections[0].before(marker);
    sections.sort((a,b) => priority(a) - priority(b)).forEach(section => marker.before(section));
    marker.remove();
  }

  function readingNavigation(root) {
    if (root.dataset.yzReadingReady) return;
    const isProduct = root.dataset.yzReading === 'product';
    const headings = [...root.querySelectorAll('h2')].filter(node => !node.closest('details,.yzpd-hero'));
    if (headings.length < 3 && isProduct) headings.push(...root.querySelectorAll('h3'));
    if (headings.length < 3) return;
    root.dataset.yzReadingReady = 'true';
    const toc = document.createElement('details');
    toc.className = 'yz-reading-toc';
    toc.open = !narrow.matches;
    const summary = document.createElement('summary');
    summary.textContent = isProduct ? 'Dans cette fiche' : 'Dans ce guide';
    const nav = document.createElement('nav');
    nav.setAttribute('aria-label', summary.textContent);
    headings.forEach(heading => {
      if (!heading.id) heading.id = `yz-${slug(heading.textContent).slice(0,75)}-${++serial}`;
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent;
      nav.append(link);
    });
    toc.append(summary, nav);
    const layout = document.createElement('div');
    layout.className = 'yz-reading-layout';
    const body = document.createElement('div');
    body.className = 'yz-reading-body';
    const heading = [...root.children].find(child => child.tagName === 'H1');
    const intro = heading?.nextElementSibling?.tagName === 'P' ? heading.nextElementSibling : null;
    const header = document.createElement('header');
    header.className = 'yz-reading-heading';
    if (heading) header.append(heading);
    if (intro) header.append(intro);
    [...root.childNodes].forEach(node => body.append(node));
    layout.append(toc, body);
    if (header.childNodes.length) root.append(header);
    root.append(layout);
    // Set the initial layout once; native details then preserves the reader's choice.
  }

  function stockState() {
    const indicator = document.querySelector('[data-yz-stock]');
    const button = document.querySelector('.product-details product-form-component button[type="submit"]');
    if (!indicator || !button || button.getAttribute('aria-busy') === 'true') return;
    // Read the native purchase state; no independent stock or quantity calculation.
    const unavailable = button.disabled && /sold out|épuisé|rupture|unavailable|indisponible/i.test(button.textContent);
    if (button.disabled && !unavailable) return;
    indicator.dataset.available = String(!unavailable);
    const label = unavailable ? 'Cette variante est indisponible' : 'Disponible pour cette sélection';
    if (indicator.textContent !== label) indicator.textContent = label;
  }

  function configureForms(root) {
    const configs = [
      {fields:['ar-marque','ar-modele','ar-annee'], action:'arSearch()'},
      {fields:['j-marque','j-modele','j-annee'], action:'jSearch()'},
      {fields:['cm','cmo','ca'], action:'doSearch()'}
    ];
    configs.forEach(config => {
      const button = root.querySelector(`[onclick="${config.action}"]`);
      if (!button || button.dataset.yzValidated) return;
      button.dataset.yzValidated = 'true';
      const fields = config.fields.map(id => document.getElementById(id));
      if (fields.some(field => !field)) return;
      const error = document.createElement('p');
      error.className = 'yz-config-error';
      error.id = `${config.fields[0]}-error`;
      error.setAttribute('role','alert');
      error.hidden = true;
      button.before(error);
      button.addEventListener('click', event => {
        const missing = fields.filter(field => !field.value);
        fields.forEach(field => {
          if (!field.value) { field.setAttribute('aria-invalid','true'); field.setAttribute('aria-describedby',error.id); }
          else { field.removeAttribute('aria-invalid'); field.removeAttribute('aria-describedby'); }
        });
        if (missing.length) {
          event.preventDefault();
          event.stopImmediatePropagation();
          error.textContent = 'Sélectionnez la marque, le modèle et l’année de votre véhicule pour poursuivre.';
          error.hidden = false;
          missing.find(field => !field.disabled)?.focus();
        } else error.hidden = true;
      }, {capture:true});
      fields.forEach(field => field.addEventListener('change', () => {
        field.removeAttribute('aria-invalid');
        field.removeAttribute('aria-describedby');
        if (fields.every(control => control.value)) error.hidden = true;
      }));
      const note = document.createElement('p');
      note.className = 'yz-config-note';
      note.textContent = 'Avant de commander, vérifiez la référence, son prix et sa compatibilité sur la fiche produit. En cas de doute, contactez-nous.';
      const link = document.createElement('a');
      link.href = '/pages/contact';
      link.textContent = ' Demander conseil';
      note.append(link);
      button.after(note);
    });
    root.querySelectorAll('#res,#ar-results,#j-results').forEach(result => {
      if (result.dataset.yzTableObserver) return;
      result.dataset.yzTableObserver = 'true';
      const refineResult = () => {
        enhanceTables(result);
        result.querySelectorAll('a[href^="/collections/"]').forEach(link => {
          if (/^voir(?: le)? produit$/i.test(link.textContent.trim())) link.textContent = 'Voir la collection';
        });
        if (result.childElementCount && !result.querySelector('.yz-config-note')) {
          const resultNote = document.createElement('p');
          resultNote.className = 'yz-config-note';
          resultNote.textContent = 'Consultez la collection, puis la fiche de la référence retenue pour vérifier son prix et sa compatibilité avant de commander.';
          result.prepend(resultNote);
        }
      };
      new MutationObserver(refineResult).observe(result,{childList:true,subtree:true});
    });
  }

  function enhance(root) {
    composeServices(root);
    enhanceFAQ(root);
    configureForms(root);
    root.querySelectorAll('[data-yz-reading="product"]').forEach(orderProductSections);
    root.querySelectorAll('.page-guide,.faq-page,.yz-collection-advice .yz-reading,[data-yz-reading],.blog-post-content rte-formatter').forEach(node => {
      node.classList.add('yz-reading');
      enhanceTables(node);
      readingNavigation(node);
    });
    root.querySelectorAll('.yzc,.yzp,[data-yz-reading],.page-guide,.faq-page').forEach(enhanceTables);
    root.querySelectorAll('#res,#ar-results,#j-results').forEach(node => { node.setAttribute('aria-live','polite'); node.setAttribute('role','status'); });
    stockState();
  }
  enhance(document);
  document.documentElement.classList.add('yz-refined');
  document.addEventListener('shopify:section:load', event => enhance(event.target));
  const purchase = document.querySelector('.product-details');
  if (purchase) new MutationObserver(stockState).observe(purchase, {childList:true,subtree:true,attributes:true,attributeFilter:['disabled','aria-busy']});
})();
